module.exports = __webpack_public_path__ + "img/Recurso 19@300x.bd4c165e.webp";